import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAppleLogo = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	fill: "none",
	viewBox: "0 0 21 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "pet__icon / 16px / ic_mail",
		children: /* @__PURE__ */ _jsx("path", {
			id: "pet__Vector",
			fill: "#4B4B4B",
			d: "M15.6215 18.28C14.6415 19.23 13.5715 19.08 12.5415 18.63C11.4515 18.17 10.4515 18.15 9.30145 18.63C7.86145 19.25 7.10145 19.07 6.24145 18.28C1.36145 13.25 2.08145 5.59 7.62145 5.31C8.97145 5.38 9.91145 6.05 10.7015 6.11C11.8815 5.87 13.0115 5.18 14.2715 5.27C15.7815 5.39 16.9215 5.99 17.6715 7.07C14.5515 8.94 15.2915 13.05 18.1515 14.2C17.5815 15.7 16.8415 17.19 15.6115 18.29L15.6215 18.28ZM10.6015 5.25C10.4515 3.02 12.2615 1.18 14.3415 1C14.6315 3.58 12.0015 5.5 10.6015 5.25Z"
		})
	})
});
const ForwardRef = forwardRef(SvgAppleLogo);
export default ForwardRef;
